import { FormatNumberOptions, useIntl } from 'react-intl';
import { useCssHandles } from '../../utils/functions';

import formatCurrency from './formatCurrency';

const formatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
});

// TypeScript thinks that all browsers have formatToParts
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const hasFormatToParts = !!formatter.formatToParts;

const CSS_HANDLES = [
	'currencyContainer',
	'currencyCode',
	'currencyLiteral',
	'currencyInteger',
	'currencyGroup',
	'currencyDecimal',
	'currencyFraction',
	'currencyInfinity',
	'currencyMinusSign',
	'currencyNan',
	'currencyPlusSign',
	'currencyPercentSign',
] as const;

const handlesMap: any = {
	currency: 'currencyCode',
	literal: 'currencyLiteral',
	integer: 'currencyInteger',
	group: 'currencyGroup',
	decimal: 'currencyDecimal',
	fraction: 'currencyFraction',
	infinity: 'currencyInfinity',
	minusSign: 'currencyMinusSign',
	nan: 'currencyNan',
	plusSign: 'currencyPlusSign',
	percentSign: 'currencyPercentSign',
};

interface Props {
	value: number;
	blockClass?: string;
	baseCssHandle?: any;
}

function FormattedCurrency({ value, blockClass, baseCssHandle }: Props) {
	const { culture } = { culture: { currency: 'BRL' } };
	const intl = useIntl();
	const { handles }: any = useCssHandles(baseCssHandle ?? `vtex-product-price-1-x`, CSS_HANDLES, blockClass);

	// In case it's IE11
	if (!hasFormatToParts) {
		const number = formatCurrency({ intl, culture, value });

		return <span className={handles.currencyContainer}>{number}</span>;
	}

	const formatOptions: FormatNumberOptions = {
		style: 'currency',
		currency: 'BRL',
	};

	//   if (culture.customCurrencyDecimalDigits != null) {
	//     formatOptions.minimumFractionDigits = culture.customCurrencyDecimalDigits
	//   }

	/**
	 * The default Romanian currency format is wrong
	 * https://stackoverflow.com/questions/57526989/return-correct-currency-for-intl-numberformat-romanian-lei
	 */
	const isRomanian = culture.currency === 'RON' && intl.locale.indexOf('ro') === 0;

	if (isRomanian) {
		formatOptions.currencyDisplay = 'name';
	}

	const result = intl.formatNumberToParts(value, formatOptions).map((part, index) => {
		const handleName = handlesMap[part.type];
		// I spent 20 min here, but could not type this properly
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		const handle = handles[handleName];

		return (
			<span key={index} className={handle}>
				{part.value}
			</span>
		);
	});

	return <span className={handles.currencyContainer}>{result}</span>;
}

export default FormattedCurrency;
